<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
  import { computed, watch } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  import { useCart } from '@/app/Checkout/composables/useCart'
  import { useFreeSamples } from '@/app/Checkout/composables/useFreeSamples'
  import { useBreakpoint } from '@/app/Checkout/composables/useBreakpoint'

  const props = defineProps({
    hasBottomBorder: {
      type: Boolean,
      default: false,
    },
  })

  const { t } = useI18n()
  const store = useStore()
  const { cart } = useCart()
  const { isMobile } = useBreakpoint()
  const { allowedFreeSamples, selectedSampleAmount, getFreeSamples } = useFreeSamples()

  // First fetch free samples when cart is available, then show block if allowed
  watch(
    () => cart.value,
    (newValue, oldValue) => {
      const hasChanged = !oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)

      if (hasChanged && newValue != null) {
        getFreeSamples()
      }
    },
    { immediate: true, deep: true },
  )

  // Show block when cart is loaded (like CartVoucherBlock – visible to all users including guests)
  const showTrigger = computed(() => cart.value != null)

  const subtitleText = computed(() =>
    String(t('app.free_samples.subtitle', { count: allowedFreeSamples.value })).replace(/%/g, ''),
  )

  // Free samples loaded by Checkout's cart watcher (updateSelectedSamplesFromCart when cart has items)

  function openModal() {
    store.dispatch('product/openFreeSamplesModal')
  }
</script>
